// src/components/sections/HotelSection/HotelSection.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './HotelSection.css';
import { amenities } from '../../../data/amenitiesData';

const HotelSection = () => {
  return (
    <section id="o-hotel" className="section hotel-section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Nossa Estrutura</span>
          <h2 className="section-title">Sua Elegância no Coração da Cidade</h2>
          <p className="section-subtitle">
            Aproveite a melhor localização de São Lourenço, no coração da cidade e a apenas 100 metros do Parque das Águas. Oferecemos diárias com um delicioso café da manhã, ou a experiência da Pensão Completa, com almoço e jantar nos restaurantes dos hotéis Alzira Plaza e Alzira Park.
          </p>
        </div>

        {/* O Swiper foi substituído por um container de grid simples */}
        <div className="amenities-container-static">
          {amenities.map((item) => (
            // --- CORREÇÃO AQUI: O link agora usa o id do item para a âncora ---
            <Link key={item.id} to={`/estrutura#${item.id}`} className="amenity-card-static">
              <div
                className="amenity-image"
                style={{ backgroundImage: `url(${Array.isArray(item.images) ? item.images[0] : item.image})` }}
              >
                <div className="overlay"></div>
                <h3 className="amenity-title">{item.name}</h3>
              </div>
            </Link>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default HotelSection;